import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
import { createAction } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "stripeTransaction",
  initialState: {
    transactionInformation: [],
    transactionDetail: [],
    updateErrors: [],
  },
  reducers: {
    informationRetrieving: (stripeTransaction, action) => {
      stripeTransaction.transactionInformation = [];
    },
    informationRetrieved: (stripeTransaction, action) => {
      stripeTransaction.transactionInformation = action.payload
        ? action.payload
        : [];
    },
    informationRetrievalFailed: (stripeTransaction, action) => {
      stripeTransaction.transactionInformation = action.payload;
    },
    detailsUpdating: (stripeTransaction, action) => {
      stripeTransaction.transactionDetail = true;
    },
    transactionDetails: (stripeTransaction, action) => {
      stripeTransaction.transactionDetail = action.payload
        ? action.payload
        : [];
    },
    detailsUpdateFailed: (stripeTransaction, action) => {
      stripeTransaction.transactionDetail = false;
      stripeTransaction.updateErrors = action.payload
        ? action.payload
        : "Error";
    },
  },
});

export const {
  informationRetrieving,
  informationRetrieved,
  informationRetrievalFailed,
  detailsUpdating,
  transactionDetails,
  detailsUpdateFailed,
} = slice.actions;

export default slice.reducer;

export const allTransactionsList = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/retrieve-transaction-list",
    method: "get",
    onStart: informationRetrieving.type,
    onSuccess: informationRetrieved.type,
    onError: informationRetrievalFailed.type,
  });

export const transactionDetail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/retrive-transaction-detail?chargeid=" + data,
    method: "get",
    onStart: detailsUpdating.type,
    onSuccess: transactionDetails.type,
    onError: detailsUpdateFailed.type,
  });

export const getAllTransactionList = createSelector(
  (state) => state.entities.stripeTransaction,
  (stripeTransaction) => stripeTransaction.transactionInformation
);
export const getTransactionDetails = createSelector(
  (state) => state.entities.stripeTransaction,
  (stripeTransaction) => stripeTransaction.transactionDetail
);
